<template>
    <div class="sale-item-in">
        <router-link :to="{ name: 'sales-card' , params:{'id' : salesArr.name.slug}}">
            <swiper 
                :options="{
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    pagination: {
                        el: '.sales-main-pagination' + saleItemIndex,
                        type: 'bullets',
                        clickable: true,
                    },
                }" 
                ref="salesMainCarousel" v-if="saleItemsParentPage != 'about'">
                <swiper-slide v-for="(slide, index) in salesArr.project_card_carousel" :key="index" v-if="!isMobileChecker">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
                <swiper-slide v-for="(slide, index) in salesArr.project_card_carousel_mobile" :key="index" v-if="isMobileChecker">
                    <div class="promo-pic" :style="'background-image: url(' + slide + ')'"></div>
                </swiper-slide>
            </swiper>
            <div class="promo-pic" :style="!isMobileChecker ? 'background-image: url(' + salesArr.project_card_carousel[0] + ')' : 'background-image: url(' + salesArr.project_card_carousel_mobile[0] + ')'" v-if="saleItemsParentPage == 'about'"></div>
            <div class="sale-content">
                <div class="action-desc" v-if="salesArr.project_theme != '' && salesArr.filter_params.available_sale">
                    <p v-html="salesArr.project_theme"></p>
                </div>
                <div class="not-avalible-sale-desc" v-if="!salesArr.filter_params.available_sale"><p><span v-if="globalLang != 'kz/'">Нет в продаже</span><span v-else>Сатылымда жоқ</span></p></div>
                <div class="favorite-item" v-if="cardID != 'favoriteSales'">
                    <button href="#" @click.prevent="sendToFavorite(salesArr), toogleActiveClass($event)" :class="{'active' : checkIfFavorite(salesArr)}" class="btn-favorite-add">
                        <svgIcon name="favorite-disactive" class="icon-favorite"/>
                        <svgIcon name="favorite-active" class="icon-favorite-active"/>
                    </button>
                </div>
                <div class="remove-item-from-favorite" v-if="cardID == 'favoriteSales'" @click.prevent="sendToFavorite(salesArr)"><svgIcon name="close" class="icon-close"/></div>
                <div class="info" :class="{'not-avalible-sale' : !salesArr.filter_params.available_sale}">
                    <h2>{{ salesArr.name.name }}</h2>
                    <div class="price-info" v-if="salesArr.filter_params.available_sale">
                        <p v-if="salesArr.project_price != ''">{{ salesArr.project_price }}</p>
                        <p v-else>
                            <span v-if="globalLang == ''">Цена по запросу</span>
                            <span v-else="globalLang == 'kz/'">Сұраныс бойынша баға</span>
                        </p>
                    </div>
                </div>
                <div class="swiper-pagination sales-main-pagination" :class="'sales-main-pagination' + saleItemIndex" v-if="!isMobileChecker"></div>
                <div class="btn-go btn-wow-effect-hover">
                    <svgIcon name="arrow-right" class="icon-right-arrow"/>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-sales-section',
        props: ['salesArr', 'saleItemIndex', 'saleItemsParentPage'],
        components: {
            svgIcon,
        },
        data () {
            return {
                cardID: this.$route.name,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            isMobileChecker: 'loadIsMobileChecker',
            favoriteLocalStorageUpdate: 'loadFavoriteLocalStorageUpdate',
        }),
        methods: {
            sendToFavorite(arr) {
                var favorites = JSON.parse(localStorage.getItem('favorite_projects_dial')) || [];
                var finder = this.checkIfFavorite(arr); // проверка наличия объекта в массиве избранных
                if (!finder) { // Добавляем объект в массив если такого объекта не обнаружено в массиве
                    favorites.push(arr);
                    localStorage.setItem('favorite_projects_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                } else { // Убираем из массива если такой объект уже есть в избранном
                    // console.log(favorites, 'asdasdasdasdasd')
                    favorites = favorites.filter(favorite => favorite.name.name != arr.name.name);
                    localStorage.setItem('favorite_projects_dial', JSON.stringify(favorites));
                    this.$store.commit('FavoriteLocalStorageUpdate', !this.favoriteLocalStorageUpdate);
                }
            },
            checkIfFavorite(arr) { // проверка наличия объекта в массиве избранных
                var favorites = JSON.parse(localStorage.getItem('favorite_projects_dial')) || [];
                var finder = favorites.some(favorite => favorite.name.name === arr.name.name); 
                return finder;
            },
            toogleActiveClass(event) {
                event.currentTarget.classList.toggle('active');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-page/sale-item.scss';
    @import '@/styles/components/sales-page/respond/sale-item-respond.scss';
    // @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>